export var YearItems = (function () {
    var items = [];
    for (var year = 2021; year <= 2100; year += 1) {
        var yearString = "".concat(year);
        items.push({ value: yearString, text: yearString });
    }
    return items;
})();
export var MonthItems = (function () {
    var items = [];
    for (var month = 1; month <= 12; month += 1) {
        var monthString = "".concat(month);
        if (monthString.length === 1)
            monthString = "0".concat(monthString);
        items.push({ value: monthString, text: monthString });
    }
    return items;
})();
